import { useState } from "react";
import { toast } from "sonner";
import { supervisorApi } from "@/lib/SupervisorApi";
import { Modal, Field, inputCls } from "./SupervisorPrimitives";

/**
 * Edit metadata + plan of an existing tenant. Everything except
 * ``tenant_code`` is mutable — the code is the immutable primary key
 * used as the DB collection prefix.
 */
export default function EditTenantDialog({ tenant, onClose, onSaved }) {
  const [form, setForm] = useState({
    business_name: tenant.business_name || "",
    business_afm: tenant.business_afm || "",
    business_address: tenant.business_address || "",
    business_phone: tenant.business_phone || "",
    business_email: tenant.business_email || "",
    plan: tenant.plan,
    notes: tenant.notes || "",
  });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await supervisorApi.updateTenant(tenant.tenant_code, form);
      toast.success("Αποθηκεύτηκε");
      onSaved();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Σφάλμα");
    } finally { setBusy(false); }
  };
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <Modal title={`Επεξεργασία: ${tenant.tenant_code}`} onClose={onClose}>
      <form onSubmit={submit}>
        <Field label="Επωνυμία">
          <input required value={form.business_name} onChange={set("business_name")} className={inputCls} />
        </Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="ΑΦΜ">
            <input value={form.business_afm} onChange={set("business_afm")} className={inputCls} />
          </Field>
          <Field label="Τηλέφωνο">
            <input value={form.business_phone} onChange={set("business_phone")} className={inputCls} />
          </Field>
        </div>
        <Field label="Διεύθυνση">
          <input value={form.business_address} onChange={set("business_address")} className={inputCls} />
        </Field>
        <Field label="Email">
          <input type="email" value={form.business_email} onChange={set("business_email")} className={inputCls} />
        </Field>
        <Field label="Plan">
          <select value={form.plan} onChange={set("plan")} className={inputCls}>
            <option value="basic">Basic</option>
            <option value="premium">Premium</option>
            <option value="enterprise">Enterprise</option>
          </select>
        </Field>
        <Field label="Σημειώσεις">
          <textarea value={form.notes} onChange={set("notes")} className={inputCls + " h-20 py-2"} />
        </Field>
        <div className="flex gap-2 justify-end pt-4 border-t border-zinc-800 -mx-6 px-6">
          <button type="button" onClick={onClose} className="h-10 px-4 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-zinc-200 text-sm font-bold">Άκυρο</button>
          <button type="submit" disabled={busy} className="h-10 px-5 rounded-lg bg-amber-600 hover:bg-amber-500 text-white font-bold text-sm disabled:opacity-40">
            {busy ? "Αποθήκευση..." : "Αποθήκευση"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
